import { useCallback, useState } from 'react';
import { Box } from '@material-ui/core';

import { SButton, SText } from '@setvi/shared/components';
import { AIGradientIcon } from '@setvi/shared/components/sicons';
import {
  StartAndorment,
  StyledMenu as StyledMenuV2,
  StyledMenuItem as StyledMenuItemV2
} from '@setvi/shared/components/intelligence/search/components/dropdown/styled';

import { SButtonProps } from '@setvi/shared/components/sbutton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { AIGradientBgColor, StyledMenu, StyledMenuItem } from './styled';

interface Items {
  icon?: JSX.Element;
  flag: boolean;
  text: string;
  disabled?: boolean;

  onClick: () => void;
}

interface AIButtonProps {
  title?: string;
  variant?: SButtonProps['variant'];
  items: Items[];
  // ! This will be removed once the new design is implemented
  newDesign?: boolean;
}

const AIButton = ({
  items,
  title = 'AI Tools',
  variant = 'contained',
  newDesign = false
}: AIButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  // Get items with flag set to true
  const currItems = items?.filter(i => i?.flag);

  const handleOpenMenu = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      if (currItems?.length === 1) currItems[0]?.onClick?.();
      else setAnchorEl(event.currentTarget);
    },
    [currItems]
  );

  const Menu = newDesign ? StyledMenuV2 : StyledMenu;
  const MenuItem = newDesign ? StyledMenuItemV2 : StyledMenuItem;

  if (!currItems?.length) return null;

  return (
    <Box onClick={e => e.stopPropagation()}>
      <SButton
        variant={variant}
        style={{
          background: variant === 'contained' && AIGradientBgColor,
          ...(newDesign && { borderRadius: 120 })
        }}
        onClick={handleOpenMenu}
        startIcon={<AIGradientIcon />}
        endIcon={
          !!items.length &&
          items.length > 1 && (
            <ExpandMoreIcon
              htmlColor={
                variant === 'contained' && newDesign ? '#fff' : 'inherit'
              }
              style={{
                rotate: anchorEl && '-180deg',
                transition: 'rotate .3s'
              }}
            />
          )
        }>
        {title}
      </SButton>

      {!!anchorEl && (
        <Menu
          open
          keepMounted
          elevation={3}
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}>
          {currItems?.map(item => (
            <MenuItem
              key={item?.text}
              onClick={() => {
                item?.onClick?.();
                setAnchorEl(null);
              }}
              disabled={item?.disabled}>
              <StartAndorment>
                {item?.icon}
                <SText>{item?.text}</SText>
              </StartAndorment>
            </MenuItem>
          ))}
        </Menu>
      )}
    </Box>
  );
};

export default AIButton;
